import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import React from 'react';
import { Button } from 'primereact/button';

import './graph.css';
import { FilterBarProps } from './interfaces';

const FilterBar: React.FC<FilterBarProps> = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  selectedTemps,
  setSelectedTemps,
  temps,
  handleSubmit,
  setTemplate_id,
  resetFilters,
}) => {
  return (
    <form className="filter__container" onSubmit={handleSubmit}>
      <div className="filter__col">
        <p>Start Date</p>
        <Calendar
          value={startDate}
          readOnlyInput
          id="from"
          onChange={(e: any) => {
            setStartDate(e.value);
          }}
          showIcon
          placeholder="Start at"
          hourFormat="24"
        />
      </div>

      <div className="filter__col">
        <p>End Date</p>
        <Calendar
          value={endDate}
          readOnlyInput
          id="to"
          onChange={(e: any) => {
            setEndDate(e.value);
          }}
          showIcon
          placeholder="End at"
          hourFormat="24"
          minDate={startDate ? startDate : undefined}
        />
      </div>
      <div className="filter__col">
        <p>Templates</p>
        <Dropdown
          value={selectedTemps}
          onChange={(e) => {
            setSelectedTemps(e.value);
            setTemplate_id(e.value.id);
          }}
          options={temps}
          optionLabel="name"
          placeholder="Select a Template"
          className="temp__dropDown"
        />
      </div>
      <div className="button__col">
        <Button
          type="submit"
          className="golden-btn filter-btn margin__left"
          label="Search"
        ></Button>
        <Button
          type="button"
          className="golden-btn filter-btn margin__left"
          label="Clear"
          onClick={resetFilters}
        />
      </div>
    </form>
  );
};

export default FilterBar;
